
<template>
    <div class="loading">
      <div>
        <img class="logoEmulsa" src="../assets/imagenes/Logotipo.svg" alt="Logo Emulsa" />
      </div>
      <div class="divAnimacion">
        <img class="iconoCarga" src="../assets/iconos/carga.svg" alt="Logo Emulsa" />
          <div class="letras">
            <span class="span">
              <img class="letra" src="../assets/iconos/r.svg" alt="Logo Emulsa" />
            </span>
            <span class="span">
              <img class="letra" src="../assets/iconos/e.svg" alt="Logo Emulsa" />
            </span>
            <span class="span">
              <img class="letra letraU" src="../assets/iconos/U.svg" alt="Logo Emulsa" />
            </span>
            <span class="span">
              <img class="letra" src="../assets/iconos/S.svg" alt="Logo Emulsa" />
            </span>
            <span class="span">
              <img class="letra" src="../assets/iconos/a.svg" alt="Logo Emulsa" />
            </span>
            <span class="span">
              <img class="letra letrap" src="../assets/iconos/p.svg" alt="Logo Emulsa" />
            </span>
            <span class="span">
              <img class="letra letrap letraP2" src="../assets/iconos/p2.svg" alt="Logo Emulsa" />
            </span>
          </div>
      </div>
</div>  

</template>

<script>
export default {
  name: 'AnimacionCarga',
  data: () => ({

     }),
  methods: {

  },
  computed:{

  }
}
</script>

<style scoped>
.loading{
  margin: 15vh auto !important;
  width: 100% !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.logoEmulsa{
  width: 20vw;
  margin-top: 10vh;
}
.divAnimacion{
  display: flex !important;
  margin-top: 10vh;
}
.span{
  min-width: 20px !important;
}
.iconoCarga{
  margin-left: -2vw;
  scale: 1;
  margin-right: 2vw;
}
.letras{
  display: flex !important;
  justify-content: space-between;
  align-items: baseline;
  gap:45px !important;
}
.letra{
  scale: 1;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.letrap{
  margin-bottom: -10px !important;
}
p{
  padding-top: 15px;
  font-size: 20px;
  font-weight: 700;
}
.loading span {
  display: inline-block;
  vertical-align: middle;
  width: 1em;
  height: 1em;
  margin: .2em;
  border-radius: .6em;
  animation: loading 1s infinite alternate;
}

.loading span:nth-of-type(2) {
  animation-delay: 0.2s;
}
.loading span:nth-of-type(3) {
  animation-delay: 0.4s;
  margin-left: -2px;
}
.loading span:nth-of-type(4) {
  animation-delay: 0.6s;
}
.loading span:nth-of-type(5) {
  margin-left: -2px;
  animation-delay: 0.8s;
}
.loading span:nth-of-type(6) {
  animation-delay: 1.0s;
}
.loading span:nth-of-type(7) {
  animation-delay: 1.2s;
}

@keyframes loading {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media only screen and (max-width:450px)  {
  .loading{
    margin: 15vh auto !important;
    width: 80% !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .logoEmulsa{
    width: 50vw;
    margin-top: 10vh;
  }
  .divAnimacion{
    width: 90vw;
    justify-content: center;
  }
  .span{
    min-width: 10px !important;
  }
  .iconoCarga{
    margin-left: 0;
    scale: .8;
    margin-right: -1vh;
  }
  .letras {
    gap: 7px !important;
  }
  .letra{
    scale: .8;
  }
  .letraU{
    margin-left: 2px !important;
  }
  .letrap {
    scale: .8;
    padding-left: 5px !important;
    padding-right: 5px !important;
    margin-bottom: -8px !important;
  }
  .letraP2{
    margin-left: -3px !important;
  }
} 
</style>